import classNames from 'classnames';
import React, { useState } from 'react';

import * as styles from './ContactForm.module.scss';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const ContactForm: React.VFC<{
	variant: 'dark' | 'light';
	formLink: string;
}> = ({ variant, formLink }) => {
	const [isIframeLoaded, setIsIframeLoaded] = useState(false);

	return (
		<div
			className={classNames(
				styles.formWrapper,
				'flex-grow-1',
				variant === 'light' && styles.lightVariant
			)}
		>
			<form>
				<div className={styles.pipedriveWebForm} data-pd-webforms={formLink}>
					{!isIframeLoaded && (
						<div className={styles.skeleton}>
							<div className="d-flex flex-column">
								<Skeleton height="20px" width="35%" />
								<Skeleton height="40px" />
							</div>
							<div className="d-flex flex-column">
								<Skeleton height="20px" width="35%" />
								<Skeleton height="40px" />
							</div>
							<div className="d-flex flex-column">
								<Skeleton height="20px" width="70%" />
								<Skeleton height="105px" />
							</div>
							<Skeleton height="155px" />
						</div>
					)}

					<iframe
						id="PipedriveForm"
						title="Contact form"
						className={styles.formIframe}
						onLoad={() =>
							// Timeout reason: We need to cover the iframe for a while longer because it has a problem inside with rendering on time
							setTimeout(() => {
								setIsIframeLoaded(true);
							}, 500)
						}
						src={`${formLink}?embeded=1&amp;uuid=idyqp6a4g`}
						loading="lazy"
					/>
				</div>
			</form>
		</div>
	);
};
